export default "__VITE_ASSET__d43df749__"